/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const n=Symbol("isSceneGraphicOrigin");function i(i){return!!i&&n in i}export{i as isSceneGraphicOrigin,n as isSceneGraphicOriginSymbol};
